import { Card } from 'react-bootstrap';
import { CartContext } from '../CartContext';
import { useContext, useState, useEffect } from 'react';
import cloudinary from 'cloudinary-core';
import React, { forwardRef } from 'react';
import html2canvas from 'html2canvas';
import "../Cart.css"

const Cart = forwardRef((props, ref) => {
  const product = props.product;
  const cart = useContext(CartContext);
  const isonSale = props.isOnSale;
  const salePrice = parseFloat(props.salePrice);
  const productQuantity = cart.getProductQuantity(product.id);
  const show = props.show;
  const setShow = props.setShow;
  const [capturedImage, setCapturedImage] = useState(null);
  const [f, setF] = useState(parseFloat(product.price).toFixed(2));
const[adjusted,setAdjusted]=useState(null)
  const cloudinaryInstance = cloudinary.Cloudinary.new({ cloud_name: 'dcuturlmb' });

  const PrintPrice = 0.2;
  let artSize;
  if(props.uploadedImage){
     artSize = parseFloat(props.Artsize) || 30;
  }else{
 artSize = 0;
  }
  
const ss = (artSize * PrintPrice).toFixed(2);
let uploadedImageUrl = "";
  useEffect(() => {

    const regularPrice = parseFloat(product.price);
    let adjustedPrice = regularPrice;
  
    if (isonSale && salePrice > 0) {
      // if (regularPrice - salePrice > 3) {
        adjustedPrice = salePrice;
        setAdjusted(adjustedPrice)
      } else {
        adjustedPrice = regularPrice;
        setAdjusted(adjustedPrice)
      }
      // console.log(props.finalImage)
    // }
  // console.log(regularPrice,isonSale,salePrice,adjustedPrice)
    setF(adjustedPrice.toFixed(2));
  }, [isonSale, salePrice, product.price]);

  const handleCapture = async () => {
    await fetch("https://api-shipping-28612190fdf4.herokuapp.com/image", {
      method: "POST",
      body: JSON.stringify({ imageUrl: props.finalImage ? props.finalImage : props.url }),

      headers: {
        "Content-Type": "application/json",
      },
    })
      .then(response => response.json())
      .then(data => {
        const el = document.getElementById('myImage');
        el.style.backgroundImage = 'url(' + data.image + ')';
        el.style.border = 'none';
        el.style.borderRadius = 0;
        el.style.boxShadow = 'none';
      })
      .catch(error => {
        console.error('Error:', error);
      });

    try {
      const canvas = await html2canvas(document.getElementById('myImage'), {
        useCORS: true,
      });
      const dataUrl = canvas.toDataURL("image/png");
      const result = await uploadImageToCloudinary(dataUrl);
      setCapturedImage(result);
      return result;
    } catch (error) {
      console.error("Error capturing div:", error);
    }
  };


const uploadImageToCloudinary = async (base64Image) => {
  try {
    const response = await fetch('https://api.cloudinary.com/v1_1/dcuturlmb/image/upload', {
      method: 'POST',
      body: new URLSearchParams({
        file: base64Image,
        upload_preset: 'ml_default',
      }),
    });

    const data = await response.json();
    uploadedImageUrl = data.secure_url;
    return uploadedImageUrl;
  } catch (error) {
    console.error('Error uploading image:', error);
    return null;
  }
};

  const total = ((parseFloat(f || 0) + parseFloat(ss)) * (productQuantity || 1)).toFixed(2);

  const add = async () => {
    if (ss === "0.00") {
      cart.addOneToCart(product.id, total, product.size, props.color, product.name, props.url, props.thumImage, 
        props.thumId, product.image2, props.rating, props.weight,ss,props.colorName4API,props.SalePrice,props.imageSize1,props.imageSize2,props.imageSize3,props.imageSize4,uploadedImageUrl);
      // setShow(false);
    } else {
      const imgurl = await handleCapture();
      cart.addOneToCart(product.id, total, product.size, props.color, product.name, imgurl, props.thumImage, props.thumId, product.image2,
         props.rating, props.weight,ss,props.colorName4API,props.SalePrice,props.imageSize1,props.imageSize2,props.imageSize3,props.imageSize4,uploadedImageUrl);
      // setShow(false);
    }
  };

  const remove = () => {
    cart.deleteFromCart(product.id);
    setShow(true);
  };

  const addWithDelay = () => {
    setTimeout(add, 1000);
  };

  return (
    <>
      <hr />

      <div className="custom-card">
  <div className="custom-card-body">
    <h3 className="custom-card-title">{product.id}</h3>
    <p className="custom-card-text">Item Price: ${f}</p>
    <p className="custom-card-text">Design Price: ${ss}</p>
    <hr />
    <h4 className="custom-card-total">Total of: ${total}</h4>
    <hr />
    {productQuantity > 0 ? (
      <div className="custom-card-actions">
        <button className="neu-button" style={{ color: "white", backgroundColor: "red" }}  onClick={remove}>
          Remove
        </button>
      </div>
    ) : (
      <div className="custom-card-actions">
        <button className="neu-button2" onClick={add}>
          Add To Cart
        </button>
      </div>
    )}
  </div>
</div>

    </>
  );
});

export default Cart;
